var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    [
      _c(
        "div",
        { staticClass: "q-pa-md row items-start q-gutter-md row" },
        [
          _c(
            "q-card",
            { staticClass: "my-card full-width" },
            [
              _c("div", [
                _c(
                  "h4",
                  { staticClass: "text-h4" },
                  [
                    _c("q-icon", {
                      staticClass: "q-pl-md q-pr-xs",
                      attrs: { name: "fas fa-broadcast-tower" }
                    }),
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.webcast.title) +
                        "\n                "
                    )
                  ],
                  1
                )
              ]),
              _c("q-card-separator"),
              _c("q-card-main", { staticClass: "row q-pa-md" }, [
                _c(
                  "div",
                  { staticClass: "text-body1 col-12 q-pl-md q-pb-md" },
                  [_vm._v(_vm._s(_vm.webcast.description))]
                ),
                _c("div", { staticClass: "text-subtitle2 col-12 q-pl-md" }, [
                  _vm._v(_vm._s(_vm.$t("webcast_start_schedule")) + ": "),
                  _c("strong", [
                    _vm._v(
                      _vm._s(_vm.fDateTime(_vm.webcast.transmission_date)) + "H"
                    )
                  ])
                ])
              ]),
              _c("q-card-separator"),
              _c(
                "q-card-actions",
                { staticClass: "row justify-end q-pa-md" },
                [
                  _c("q-btn", {
                    staticClass: "col-4",
                    attrs: {
                      color: "tertiary",
                      label: _vm.$t("back"),
                      icon: _vm.getIconBtn("back")
                    },
                    on: { click: _vm.closeModal }
                  }),
                  _c("q-btn", {
                    staticClass: "col-4",
                    attrs: {
                      color: "primary",
                      label: _vm.$t("start"),
                      icon: _vm.getIconBtn(_vm.activity)
                    },
                    on: {
                      click: function($event) {
                        return _vm.gotoClass(_vm.webcast.webcast_id)
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.show_modal_webcast
        ? _c(
            "q-modal",
            {
              attrs: {
                "content-css": { minWidth: "100vw", minHeight: "100vh" },
                "no-backdrop-dismiss": "",
                "no-esc-dismiss": ""
              },
              model: {
                value: _vm.show_modal_webcast,
                callback: function($$v) {
                  _vm.show_modal_webcast = $$v
                },
                expression: "show_modal_webcast"
              }
            },
            [
              _c(
                "q-modal-layout",
                [
                  _c(
                    "q-toolbar",
                    { attrs: { slot: "header" }, slot: "header" },
                    [
                      _c("q-btn", {
                        attrs: {
                          flat: "",
                          round: "",
                          dense: "",
                          icon: "fas fa-times"
                        },
                        on: {
                          click: function($event) {
                            return _vm.hideModalWebcast()
                          }
                        }
                      }),
                      _c("q-toolbar-title", [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.selected_webcast.title) +
                            "\n                "
                        )
                      ])
                    ],
                    1
                  ),
                  _vm.show_modal_webcast
                    ? _c("webcast", {
                        attrs: {
                          webcast: _vm.selected_webcast,
                          live: _vm.firebase_webcast_data
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }